var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel", attrs: { id: "fivem-benefits" } }, [
    _c("p", { staticClass: "order-benefits" }, [
      _c("span", {
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("checkout:stepone.game_checkout_info.fivem.description")
          ),
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }